// utils > Time

export function convertFrom24To12(value: number) {
	let h = Math.floor(value)
	const min = Math.floor((value % 1) * 60)
	let period = 'AM'

	if (h === 0) {
		h = 12
	} else if (h > 11) {
		if (h > 12) h -= 12
		period = 'PM'
	}

	return {
		hour: h,
		minute: min,
		period
	}
}
